import { Route } from "react-router-dom";
import { Home } from "./views";

export const HOME_ROUTES = [<Route path="/" element={<Home />} />];
export { Home } from "./views";
